import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class AnalyticLogsService extends RestfulService<Models.AnalyticLog> {

  constructor(public restService: RestService) {
    super(Models.AnalyticLog);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('analytic-logs');
  }
}
